const MODIFY_LIMIT_TYPES = {
    COMMERCE: "LC",
    ATM: "LN"
}

module.exports = MODIFY_LIMIT_TYPES;
